import { useTranslation } from "react-i18next";
import EmptyState from "src/components/EmptyState/EmptyState";
import { RecencyChip } from "src/components/RecencyChip/RecencyChip";
import { usePraxisSoftwareSync } from "src/context/PraxisSoftwareSyncContext";

/** Full activity table for the standalone page — same table system the rest of the app
 *  uses (.table-container/.dashboard-table, see e.g. Upload.tsx), not the compact
 *  scrollable list the narrower Settings sub-section uses (PraxisSoftwareSyncLogList). */
export function PraxisSoftwareSyncLogTable() {
    const { t } = useTranslation();
    const { syncLog } = usePraxisSoftwareSync();

    return (
        <div className="table-container pvs-sync-log-table-container">
            {syncLog.length === 0 ? (
                <EmptyState message={t("praxisSoftwareSync.panelNoActivity")} />
            ) : (
                <table className="dashboard-table">
                    <thead>
                        <tr>
                            <th>{t("praxisSoftwareSync.logColTime")}</th>
                            <th>{t("praxisSoftwareSync.logColType")}</th>
                            <th>{t("praxisSoftwareSync.logColFile")}</th>
                            <th>{t("praxisSoftwareSync.logColResult")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {syncLog.map((entry) => (
                            <tr key={entry.id}>
                                <td className="pvs-sync-log-table__time">
                                    <div className="pvs-sync-log-table__time-stack">
                                        <RecencyChip timestamp={entry.timestamp} />
                                        <span className="pvs-sync-log-table__time-abs">
                                            {new Date(entry.timestamp).toLocaleString("de-DE")}
                                        </span>
                                    </div>
                                </td>
                                <td>
                                    <span className={`pvs-sync-confirm-list__type pvs-sync-confirm-list__type--${entry.folderType}`}>
                                        {entry.folderType === "gdt" ? t("praxisSoftwareSync.gdtFolderShort") : t("praxisSoftwareSync.datFolderShort")}
                                    </span>
                                </td>
                                <td className="pvs-sync-log-table__file">{entry.filename}</td>
                                <td className={`pvs-sync-log-table__result pvs-sync-log-table__result--${entry.status}`}>
                                    {entry.message}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}
